import { render, staticRenderFns } from "./alpha-slider.vue?vue&type=template&id=068c66cb&"
import script from "./alpha-slider.vue?vue&type=script&lang=js&"
export * from "./alpha-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068c66cb')) {
      api.createRecord('068c66cb', component.options)
    } else {
      api.reload('068c66cb', component.options)
    }
    module.hot.accept("./alpha-slider.vue?vue&type=template&id=068c66cb&", function () {
      api.rerender('068c66cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
export default component.exports